function addTitleFromAlt($images) {
    $images.each(function(){
      var $img = $(this);
      var altText = $img.attr('alt');

      // Only add title if alt exists and title not set
      if(altText && !$img.attr('title')){
        $img.attr('title', altText);
      }
    });
  }
jQuery(document).ready(function($) {
    $(".collection-slider .swiper-button-prev, .collection-slider .swiper-button-next").wrapAll('<div class="arrow-buttons-wrapper"></div>');

    // Handle add to cart for product page - override default behavior
    $(document).on('click', '.js-grid-cart', function (e) {
      e.preventDefault();
      e.stopPropagation(); // Prevent other handlers from firing

      var $btn = $(this);
      
      // Get variant ID from data-id attribute (updated by dropdown change handler)
      var variantId = $btn.attr('data-id') || $btn.data('id');
      
      // Get quantity from quantity input field
      var $qtyInput = $('.qty-input');
      var quantity = $qtyInput.length ? parseInt($qtyInput.val()) || 1 : 1;

      // Check if button is disabled or variant ID is missing
      if (!variantId || $btn.hasClass('disabled') || $btn.prop('disabled')) {
        return;
      }

      $btn.addClass('is-loading').prop('disabled', true);

      // Use Shopify.addItem if available (for cart updates), otherwise use AJAX
      if (typeof Shopify !== 'undefined' && Shopify.addItem) {
        Shopify.addItem(variantId, quantity, function(item) {
          var htmlVariant = item.variant_title !== null ? '<i>('+item.variant_title+')</i>' : '';
          var styleCart = $('.js-mini-cart').attr("data-cartmini");
          if(styleCart != 'true'){
            var htmlAlert = '<div class="media mt-2 alert--cart"><a class="mr-3" href="/cart"><img class="lazyload" data-src="'+item.image+'"></a><div class="media-body align-self-center"><p class="m-0 font-weight-bold">'+item.product_title+' x '+ item.quantity +'</p>'+htmlVariant+'<div><div>';
          }
          if(typeof theme !== 'undefined' && theme.miniCart) {
            theme.miniCart.generateCart();
            theme.miniCart.updateElements();
          }
          setTimeout(function() {
            if(typeof theme !== 'undefined' && theme.alert && styleCart != 'true') {
              theme.alert.new(theme.strings.addToCartSuccess, htmlAlert, 3000, 'notice');
            }
            $btn.removeClass('is-loading').prop('disabled', false);
          }, 300);
          if(typeof theme !== 'undefined' && theme.cartpage){
            location.reload();
            $("html, body").animate({ scrollTop: 0 }, "slow");
          }
        });
      } else {
        // Fallback to AJAX if Shopify.addItem is not available
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: {
            id: variantId,
            quantity: quantity
          },
          dataType: 'json',
          success: function (item) {
            // Update cart if miniCart exists
            if(typeof theme !== 'undefined' && theme.miniCart) {
              theme.miniCart.generateCart();
              theme.miniCart.updateElements();
            }
            $btn.removeClass('is-loading').prop('disabled', false);
          },
          error: function (xhr) {
            $btn.removeClass('is-loading').prop('disabled', false);
            var errorMsg = 'Unable to add product to cart.';
            if(xhr.responseJSON && xhr.responseJSON.description) {
              errorMsg = xhr.responseJSON.description;
            }
            alert(errorMsg);
          }
        });
      }
    });

    // Also handle .product-form__cart-submit for other pages
    $(document).on('click', '.product-form__cart-submit', function (e) {
      e.preventDefault();

      var $btn = $(this);
      var variantId = $btn.data('variant-id');

      if (!variantId || $btn.prop('disabled')) return;

      $btn.addClass('loading').prop('disabled', true);

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          id: variantId,
          quantity: 1
        },
        dataType: 'json',
        success: function () {
          // Redirect to cart (same behavior as product page)
          window.location.href = '/cart';
        },
        error: function () {
          $btn.removeClass('loading').prop('disabled', false);
          alert('Unable to add product to cart.');
        }
      });
    });
});


//Add title attribute by js 05-01-2026
document.addEventListener("DOMContentLoaded", function() {
  // Function to add title from alt
  function addTitleFromAlt(img) {
    img.forEach(function(image){
      if(image.alt && !image.title){
        image.title = image.alt;
      }
    });
  }
  // 1️⃣ Add title for all images already in DOM
  addTitleFromAlt(document.querySelectorAll('img'));
  // 2️⃣ Watch for new images added later (lazyload or AJAX)
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation){
      mutation.addedNodes.forEach(function(node){
        if(node.tagName === 'IMG'){
          addTitleFromAlt([node]);
        } else if(node.querySelectorAll){
          addTitleFromAlt(node.querySelectorAll('img'));
        }
      });
    });
  });
  // Observe the whole body
  observer.observe(document.body, { childList: true, subtree: true });
});





// 22-12-2025

// buy it now button
// document.addEventListener("DOMContentLoaded", function () {
//   const buyNowBtn = document.querySelector(
//     '.shopify-payment-button__button'
//   );

//   if (buyNowBtn) {
//     buyNowBtn.textContent = 'Buy it now';
//   }

//   fetch('/cart/add.js', {
//   method: 'POST',
//   headers: {
//     'Content-Type': 'application/json'
//   },
//   body: JSON.stringify({
//     id: document.querySelector('[name="id"]').value,
//     quantity: 1
//   })
// });
// });
// buy it now button


// 18-12-205 







document.addEventListener("DOMContentLoaded", function () {

    // Thumbnail slider only
    // $('.product-single__thumbnails-{{ section.id }}').slick({
    //     slidesToShow: 5,
    //     slidesToScroll: 1,
    //     dots: false,
    //     infinite: false,
    //     arrows: true,
    //     focusOnSelect: true
    // });

    // Change main image on thumb click
  //   $('.product-single__thumbnails-{{ section.id }} img').on('click', function () { let newSrc = $(this).attr('src').replace('_100x100', '_800x'); $('.my-gallery.gallery-wrap{{ section.id }} img').attr('src', newSrc); });
});



document.addEventListener("DOMContentLoaded", function () {

  // Disable lightbox click
  // document.querySelectorAll('.my-gallery.gallery-wrap{{ section.id }} a').forEach(function(el){ el.removeAttribute('data-size'); el.style.pointerEvents = "none"; });


  // Disable click on thumbnails too
  document.querySelectorAll('.product-single__thumbnail-item a').forEach(function(el){
      el.style.pointerEvents = "none";
  });

});


// term-condition

(function() {
  const sidebar   = document.querySelector('.terms-sticky');
  const container = document.querySelector('.terms-container');

  if (!sidebar || !container) return;

  const sidebarHeight = sidebar.offsetHeight;

  function handleSticky() {

  
    if (window.innerWidth <= 991) {
      sidebar.style.position = 'static';
      sidebar.style.top = '';
      sidebar.style.bottom = '';
      return;
    }

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const containerTop = container.offsetTop;
    const containerHeight = container.offsetHeight;

    if (
      scrollTop > containerTop &&
      scrollTop + sidebarHeight < containerTop + containerHeight
    ) {
      sidebar.style.position = 'fixed';
      sidebar.style.top = '200px';
      sidebar.style.bottom = 'unset';
    } 
    else if (scrollTop + sidebarHeight >= containerTop + containerHeight) {
      sidebar.style.position = 'absolute';
      sidebar.style.top = '200px';
      sidebar.style.bottom = '0';
    } 
    else {
      sidebar.style.position = 'static';
      sidebar.style.top = '';
      sidebar.style.bottom = '';
    }
  }

  window.addEventListener('scroll', handleSticky);
  window.addEventListener('resize', handleSticky);
})();




// retun script
(function() {
  const sidebar   = document.querySelector('.return-sticky');
  const container = document.querySelector('.return-container');

  if (!sidebar || !container) return;

  const sidebarHeight = sidebar.offsetHeight;

  function handleSticky() {

   
    if (window.innerWidth <= 991) {
      sidebar.style.position = 'static';
      sidebar.style.top = '';
      sidebar.style.bottom = '';
      return;
    }

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const containerTop = container.offsetTop;
    const containerHeight = container.offsetHeight;

    if (
      scrollTop > containerTop &&
      scrollTop + sidebarHeight < containerTop + containerHeight
    ) {
      sidebar.style.position = 'fixed';
      sidebar.style.top = '200px';
      sidebar.style.bottom = 'unset';
    } 
    else if (scrollTop + sidebarHeight >= containerTop + containerHeight) {
      sidebar.style.position = 'absolute';
      sidebar.style.top = '200px';
      sidebar.style.bottom = '0';
    } 
    else {
      sidebar.style.position = 'static';
      sidebar.style.top = '';
      sidebar.style.bottom = '';
    }
  }

  window.addEventListener('scroll', handleSticky);
  window.addEventListener('resize', handleSticky);
})();


// faq page script

(function() {
  const sidebar   = document.querySelector('.faq-sticky');
  const container = document.querySelector('.faq-container');

  if (!sidebar || !container) return;

  const sidebarHeight = sidebar.offsetHeight;

  function handleSticky() {
   
    if (window.innerWidth <= 991) {
      sidebar.style.position = 'static';
      sidebar.style.top = '';
      sidebar.style.bottom = '';
      return;
    }

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const containerTop = container.offsetTop;
    const containerHeight = container.offsetHeight;

    if (
      scrollTop > containerTop &&
      scrollTop + sidebarHeight < containerTop + containerHeight
    ) {
      sidebar.style.position = 'fixed';
      sidebar.style.top = '200px';
      sidebar.style.bottom = 'unset';
    } 
    else if (scrollTop + sidebarHeight >= containerTop + containerHeight) {
      sidebar.style.position = 'absolute';
      sidebar.style.top = '200px';
      sidebar.style.bottom = '0';
    } 
    else {
      sidebar.style.position = 'static';
      sidebar.style.top = '';
      sidebar.style.bottom = '';
    }
  }

  window.addEventListener('scroll', handleSticky);
  window.addEventListener('resize', handleSticky);
})();


// privacy policy script

(function() {
  const sidebar   = document.querySelector('.policy-sticky');
  const container = document.querySelector('.policy-container');

  if (!sidebar || !container) return;

  const sidebarHeight = sidebar.offsetHeight;

  function handleSticky() {

    if (window.innerWidth <= 991) {
      sidebar.style.position = 'static';
      sidebar.style.top = '';
      sidebar.style.bottom = '';
      return;
    }


    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const containerTop = container.offsetTop;
    const containerHeight = container.offsetHeight;

    if (
      scrollTop > containerTop &&
      scrollTop + sidebarHeight < containerTop + containerHeight
    ) {
      sidebar.style.position = 'fixed';
      sidebar.style.top = '200px';
      sidebar.style.bottom = 'unset';
    } 
    else if (scrollTop + sidebarHeight >= containerTop + containerHeight) {
      sidebar.style.position = 'absolute';
      sidebar.style.top = '200px';
      sidebar.style.bottom = '0';
    } 
    else {
      sidebar.style.position = 'static';
      sidebar.style.top = '';
      sidebar.style.bottom = '';
    }
  }

  window.addEventListener('scroll', handleSticky);
  window.addEventListener('resize', handleSticky);
})();



// quantity buttons - handle multiple quantity inputs on page
jQuery(document).ready(function($) {
  $(document).on('click', '.qty-btn.plus', function(e) {
    e.preventDefault();
    var $qtyInput = $(this).siblings('.qty-input');
    if($qtyInput.length) {
      var currentVal = parseInt($qtyInput.val()) || 1;
      $qtyInput.val(currentVal + 1);
      // Trigger change event to update any listeners
      $qtyInput.trigger('change');
    }
  });

  $(document).on('click', '.qty-btn.minus', function(e) {
    e.preventDefault();
    var $qtyInput = $(this).siblings('.qty-input');
    if($qtyInput.length) {
      var currentVal = parseInt($qtyInput.val()) || 1;
      if(currentVal > 1) {
        $qtyInput.val(currentVal - 1);
        // Trigger change event to update any listeners
        $qtyInput.trigger('change');
      }
    }
  });
});




// 23-12-2025


document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('.quantity-box').forEach(function(box) {

    const minusBtn = box.querySelector('.qty-btn.minus');
    const plusBtn  = box.querySelector('.qty-btn.plus');
    const input    = box.querySelector('.qty-input');

    if (!minusBtn || !plusBtn || !input) return;

    plusBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      let value = parseInt(input.value) || 1;
      input.value = value + 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    minusBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      let value = parseInt(input.value) || 1;
      if (value > 1) {
        input.value = value - 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

  });

});



// 26-12 whishlist remove button js


document.addEventListener('DOMContentLoaded', function () {

  function initWishlistDots() {

    document.querySelectorAll('.wishlist-simple-image').forEach(link => {

      if (link.querySelector('.wishlist-menu-btn')) return;

      const dot = document.createElement('div');
      dot.className = 'wishlist-menu-btn';
      dot.innerHTML = '⋮';

      const popup = document.createElement('div');
      popup.className = 'wishlist-dropdown';
      popup.innerHTML = `
        <button type="button" class="wishlist-remove-btn">
          🗑 Remove from list
        </button>
      `;

      link.appendChild(dot);
      link.appendChild(popup);

      /* 3-dot click → ONLY popup */
      dot.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        document.querySelectorAll('.wishlist-dropdown')
          .forEach(p => p.style.display = 'none');

        popup.style.display =
          popup.style.display === 'block' ? 'none' : 'block';
      });

      /* Remove click → ONLY remove */
      popup.querySelector('.wishlist-remove-btn')
  .addEventListener('click', function (e) {
    e.preventDefault();
    e.stopPropagation();

    const card = link.closest('.wishlist-simple-card');
    const handle = link.href.split('/products/')[1];

    /* REMOVE FROM ALL LOCALSTORAGE WISHLIST KEYS */
    Object.keys(localStorage).forEach(key => {
      try {
        const data = JSON.parse(localStorage.getItem(key));
        if (Array.isArray(data)) {
          const updated = data.filter(item =>
            item !== handle &&
            item?.handle !== handle &&
            item?.productHandle !== handle
          );
          localStorage.setItem(key, JSON.stringify(updated));
        }
      } catch (err) {}
    });

    card.remove();
  });


      link.addEventListener('click', function (e) {
        if (e.target.closest('.wishlist-menu-btn') ||
            e.target.closest('.wishlist-dropdown')) {
          e.preventDefault();
        }
      });
    });
  }

  initWishlistDots();

  const container = document.querySelector('.js-wishlist-content');
  if (container) {
    new MutationObserver(initWishlistDots)
      .observe(container, { childList: true, subtree: true });
  }

});


(function () {
  const wishlistContainer = document.querySelector('.js-wishlist-content');
  const emptyBox = document.querySelector('.wishlist-empty-state');

  if (!wishlistContainer || !emptyBox) return;

  function checkWishlist() {
    const items = wishlistContainer.querySelectorAll('.wishlist-simple-card');

    if (items.length > 0) {
      emptyBox.style.display = 'none';
    } else {
      emptyBox.style.display = 'flex';
    }
  }

  const observer = new MutationObserver(function () {
    checkWishlist();
  });

  observer.observe(wishlistContainer, {
    childList: true,
    subtree: true
  });

  setTimeout(checkWishlist, 300);

  document.addEventListener('click', function (e) {
    if (e.target.closest('.wishlist-remove-btn')) {
      setTimeout(checkWishlist, 200);
    }
  });
})();

// 🔥 CLICK OUTSIDE → CLOSE WISHLIST DROPDOWN
document.addEventListener('click', function (e) {

  // Agar click wishlist button ya dropdown ke andar nahi hua
  if (
    !e.target.closest('.wishlist-menu-btn') &&
    !e.target.closest('.wishlist-dropdown')
  ) {
    document.querySelectorAll('.wishlist-dropdown').forEach(popup => {
      popup.style.display = 'none';
    });
  }

});

// 26-12 whishlist remove button js end



// 30-12-2025


document.addEventListener("DOMContentLoaded", function () {

  document.querySelectorAll(".custom-search-box").forEach(function (form) {

    const searchInput = form.querySelector('input[type="search"]');
    const resultsDropdown = form.querySelector(".search-results-dropdown");

    if (!searchInput || !resultsDropdown) return;

    let debounceTimeout;

    searchInput.addEventListener("input", function () {
      const query = this.value.trim();

      clearTimeout(debounceTimeout);

      if (query.length < 1) {
        resultsDropdown.style.display = "none";
        resultsDropdown.innerHTML = "";
        return;
      }

      debounceTimeout = setTimeout(() => {
        fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=5`)
          .then(response => response.json())
          .then(data => {
            const products = data.resources.results.products || [];

            if (products.length === 0) {
              resultsDropdown.innerHTML = "<p style='padding:10px;'>No results found</p>";
              resultsDropdown.style.display = "block";
              return;
            }

            const html =
              `<ul>` +
              products.map(product => `
                <li>
                  <a href="${product.url}">
                    <img src="${product.image}" alt="${product.title}" style="width:40px;height:40px;margin-right:10px;vertical-align:middle;">
                    ${product.title}
                  </a>
                </li>
              `).join("") +
              `</ul>`;

            resultsDropdown.innerHTML = html;
            resultsDropdown.style.display = "block";
          });
      }, 300);
    });

    document.addEventListener("click", function (e) {
      if (!form.contains(e.target)) {
        resultsDropdown.style.display = "none";
      }
    });

  });

});




// 09-01-2026

$(document).on('click', '.js-wishlist-add-to-cart', function () {
  var $btn = $(this);
  var variantId = $btn.data('variant-id');

  if (!variantId) return;

  $btn.prop('disabled', true).addClass('loading');

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      id: variantId,
      quantity: 1
    },
    dataType: 'json',
    success: function () {
      $btn.removeClass('loading').text(theme.strings.addedToCart);

      // OPTIONAL: update cart drawer / cart count
      $(document).trigger('cart:refresh');

    },
    error: function () {
      $btn.prop('disabled', false).removeClass('loading');
      alert('Unable to add product to cart');
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {

  const sidebar = document.querySelector(".facets-container.js-stick-parent");
  const parent = document.querySelector("#main-collection-filters");
  const grid = document.querySelector("#ProductGridContainer");

  if (!sidebar || !parent || !grid) return;

  const headerOffset = 200; // same as CSS top value

  function handleBottomFix() {

    if (!sidebar.classList.contains("is_stuck")) return;

    const gridRect = grid.getBoundingClientRect();
    const sidebarHeight = sidebar.offsetHeight;

    if (gridRect.bottom <= sidebarHeight + headerOffset) {

      sidebar.style.position = "absolute";
      sidebar.style.top = (parent.offsetHeight - sidebarHeight) + "px";

    } else {

      sidebar.style.position = "fixed";
      sidebar.style.top = headerOffset + "px";

    }
  }

  window.addEventListener("scroll", handleBottomFix);
  window.addEventListener("resize", handleBottomFix);

});




// 26-01-2026
/* code for image zoom start */

